






import { Vue, Component, Prop } from 'vue-property-decorator';
import { INode, TreeBranch } from './TreeBranch';
import VueD3 from '../VueD3.vue';

@Component({
  components: {
    VueD3,
  },
})
export default class ChartWrapper extends Vue {
  @Prop() readonly width: number | undefined;
  @Prop() readonly height: number | undefined;
  @Prop() readonly exportTitle: string | undefined;
  @Prop() readonly exportFileName: string | undefined;
  @Prop({ default: false }) readonly showExport!: boolean;
  @Prop({ default: true }) readonly showValues!: boolean;
  @Prop({ required: true }) readonly nodes!: INode[];

  vinstance: TreeBranch | null = null;

  mounted() {
    this.draw();
  }

  draw() {
    this.vinstance = new TreeBranch({
      target: this.$refs['vis-ref'],
      nodes: this.nodes,
      exportFileName: this.exportFileName,
      exportTitle: this.exportTitle,
      width: this.width,
      height: this.height,
      showValues: this.showValues,
    });
  }

  handleExportPng() {
    if (this.vinstance) {
      this.vinstance.exportToPng();
    }
  }
}
